const enums = {
    MANAGE_USERS: 'manage-users',
    ADMIN: 'admin',
};

export default Object.freeze(enums);